import { Component, Input, ViewEncapsulation } from '@angular/core';
import { NgIf } from '@angular/common';

import { pageTransitions } from '../../../../shared/animations/page-transitions';
import { CoilSegment } from '../../../models/coil-segment';

import { MetalCoatingComponent } from './metal-coating.component';
import { OrganicCoatingComponent } from './organic-coating.component';
import { RoughnessComponent } from './roughness.component';
import { SurfaceCleanlinessComponent } from './surface-cleanliness.component';
import { ChemicalSurfaceTreatmentComponent } from './chemical-surface-treatment.component';

@Component({
	selector: 'copo-coating-surface-characteristics',
	templateUrl: './coating-surface-characteristics.component.html',
	styleUrl: '../aqdb-batch-card.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		NgIf,
		MetalCoatingComponent,
		OrganicCoatingComponent,
		RoughnessComponent,
		SurfaceCleanlinessComponent,
		ChemicalSurfaceTreatmentComponent
	]
})
export class CoatingSurfaceCharacteristicsComponent {
	@Input() isValidServiceAvailable = false;
	@Input() segment?: CoilSegment;
}
